import { CardFiled } from "src/modules/pe-landing-module/data/interfaces"

/* Protopia Ecosystem component */
export interface ICardFieldContentProps {
   data: CardFiled
   value: any
}
const CardFieldContent = ({data, value, ...props}: ICardFieldContentProps): JSX.Element => {
    // switch( data.rype ) {
    //     default:
    //         return <div>
    //                 <div>
    //                     { JSON.stringify( value ) }
    //                 </div>
    //                 <div className="label">
    //                     { data.type }
    //                 </div> 
    //         </div>
    // }
}
export default CardFieldContent